export default __webpack_public_path__ + "static/media/second-about.7a30013c.png";